var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./DeleteReportIcon.module.scss";
import { Icon } from "@eightfold.ai/octuple";
import { IconName } from "@eightfold.ai/octuple";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
var DeleteReportIcon = function (_a) {
    var reportId = _a.reportId, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (_jsx("div", __assign({ className: "".concat(styles.deleteIconContainer, " ").concat(className), "data-testid": "report-delete-".concat(reportId) }, getAutomationTag(TestTag.BtnDeleteReport, reportId), { onClick: onClick }, { children: _jsx(Icon, { path: IconName.mdiDelete }) })));
};
export default DeleteReportIcon;
